import { PriceBase } from "@jog/react-components";
import React from "react";
export const Price = React.memo(PriceBase({
    type: "JC",
}));
